import { render } from "./CLayerPriceInput.vue?vue&type=template&id=60933ad7"
import script from "./CLayerPriceInput.vue?vue&type=script&lang=js"
export * from "./CLayerPriceInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__